import { render, staticRenderFns } from "./CanvasEdit.vue?vue&type=template&id=6fdc878e&scoped=true&"
import script from "./CanvasEdit.vue?vue&type=script&lang=js&"
export * from "./CanvasEdit.vue?vue&type=script&lang=js&"
import style0 from "./CanvasEdit.vue?vue&type=style&index=0&id=6fdc878e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc878e",
  null
  
)

export default component.exports